import { render, staticRenderFns } from "./StudentTemplateModel.vue?vue&type=template&id=f3d1acde&scoped=true&"
import script from "./StudentTemplateModel.vue?vue&type=script&lang=js&"
export * from "./StudentTemplateModel.vue?vue&type=script&lang=js&"
import style0 from "./StudentTemplateModel.vue?vue&type=style&index=0&id=f3d1acde&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3d1acde",
  null
  
)

export default component.exports